import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import './styles.scss';
import { MoreVertical } from '@stb-svg';
import { NavLink } from 'react-router-dom';

export default function DropdownForTable({ data, children, direction }) {
  const [isOpen, setIsOpen] = useState(false);

  const renderMenuItem = (item, index) => {
    // If item is a group with children - render as submenu
    if (item.isGroup && item.children) {
      return (
        <div key={index} className="dropdown-submenu">
          <DropdownItem className="dropdown-item-with-submenu">
            {item.title}
            <span className="submenu-arrow">‹</span>
          </DropdownItem>
          <div className="dropdown-submenu-content">
            {item.children.map((childItem, childIndex) => {
              if (childItem.to) {
                return (
                  <NavLink key={`${index}-${childIndex}`} to={childItem.to}>
                    <DropdownItem>{childItem.title}</DropdownItem>
                  </NavLink>
                );
              } else {
                return (
                  <DropdownItem
                    key={`${index}-${childIndex}`}
                    onClick={childItem.onClick}
                    href={childItem.href}
                  >
                    {childItem.title}
                  </DropdownItem>
                );
              }
            })}
          </div>
        </div>
      );
    }

    // Regular menu item
    if (item.to) {
      return (
        <NavLink key={index} to={item.to}>
          <DropdownItem>{item.title}</DropdownItem>
        </NavLink>
      );
    } else {
      return (
        <DropdownItem key={index} onClick={item.onClick} href={item.href}>
          {item.title}
        </DropdownItem>
      );
    }
  };

  return (
    <Dropdown direction={direction} isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
      <DropdownToggle tag="div" data-toggle="dropdown" aria-expanded={isOpen}>
        {children ? (
          children
        ) : (
          <button className="btn btn-sm">
            <img src={MoreVertical} />
          </button>
        )}
      </DropdownToggle>
      <DropdownMenu container="body" className="action-button-dropdown">
        {data.map((item, index) => renderMenuItem(item, index))}
      </DropdownMenu>
    </Dropdown>
  );
}

DropdownForTable.defaultProps = {
  data: [],
  direction: 'left',
};

DropdownForTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      onClick: PropTypes.func,
    })
  ),
  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
  children: PropTypes.node,
};
